/*波兰语*/
export default {
    route: {
        'title': 'System publikacji informacji',
        'home': 'Strona główna',
        'terminal': 'Terminal',
        'program': 'Program',
        'h5program': 'Program',
        'my': 'Moje',
        'remote_control': 'Pilot',
        'task_details': 'Szczegóły zadania',
        'add_task': 'Dodaj zadanie',
        'program_list': 'Lista programów',
        'terminal_info': 'Informacje o terminalu',
        'add_resolution': 'Dodaj rozdzielczość',
        'add_program': 'Dodaj program',
        'material_management': 'Zarządzanie materiałami',
        'create_program': 'Utwórz program',
        'login': 'Zaloguj się',
        'reset_password': 'Zresetuj hasło',
        'change_password': 'Zmień hasło',
        'preview': 'Podgląd'
    },
    append_field:{
        'input_code': 'Proszę wprowadzić kod weryfikacyjny',
        'code_error': 'Błędny kod weryfikacyjny',
        'fill_code': 'Proszę wypełnić kod weryfikacyjny',
        "dOut": "3D obrót na zewnątrz",
        "dIn": "3D obrót do wewnątrz",
        "dxiao": "Efekt ramki 3D",
        "selectImage": "Proszę wybrać obraz",
        "onlySelectOneImage": "Można wybrać tylko jeden obraz",
        "imageFormatError": "Błędny format obrazu",
        "cancel": "Anuluj",
        "selectedNumber": "Wybrano",
        "confirm": "Potwierdź",
        "loadinga": "Ładowanie...",
        "loadingb": "Ładowanie",
        "uploading": "Przesyłanie",
        "selectStartDates": "Wybierz datę rozpoczęcia",
        "selectEndDates": "Wybierz datę zakończenia",
        "createTask": "Utwórz zadanie",
        "selectPrograms": "Wybierz programy",
        "createPrograms": "Utwórz programy",
        "editTask": "Edytuj zadanie",
        "fillTaskName": "Proszę wprowadzić nazwę",
        "selectTaskGroup": "Proszę wybrać grupę zadań",
        "selectProgram": "Proszę wybrać program",
        "selected": "Wybrano",
        "programs": "programów",
        "selectDevice": "Proszę wybrać urządzenie",
        "sendTaskSuccess": "Zadanie wysłane pomyślnie",
        "taskName": "Nazwa",
        "playMode": "Tryb odtwarzania",
        "replaceMode": "Tryb zastępowania",
        "appendMode": "Tryb dodawania",
        'apotpatterns': 'Tryb wstawiania',
        "dateRange": "Zakres dat odtwarzania",
        "timeRange": "Zakres czasu odtwarzania",
        "taskPeriod": "Określony tydzień",
        "mon": "Pon",
        "tue": "Wt",
        "wed": "Śr",
        "thu": "Czw",
        "fri": "Pt",
        "sat": "Sob",
        "sun": "Ndz",
        "back": "Powrót",
        "programList": "Lista programów",
        "deviceList": "Lista urządzeń",
        "enterContent": "Proszę wprowadzić treść",
        "taskGroup": "Grupa zadań",
        "selectStartDate": "Proszę wybrać datę rozpoczęcia",
        "selectEndDate": "Proszę wybrać datę zakończenia",
        "selectStartTime": "Proszę wybrać czas rozpoczęcia",
        "selectEndTime": "Proszę wybrać czas zakończenia",
        "addTask": "Dodaj zadanie",
        "topLeft": "Górny lewy róg",
        "topCenter": "Górny środek",
        "topRight": "Górny prawy róg",
        "leftCenter": "Lewy środek",
        "center": "Środek",
        "rightCenter": "Prawy środek",
        "bottomLeft": "Dolny lewy róg",
        "bottomCenter": "Dolny środek",
        "bottomRight": "Dolny prawy róg",
        "enterText": "Proszę wprowadzić tekst",
        "fontColor": "Kolor czcionki",
        "bgColor": "Kolor tła",
        "scrollDirection": "Kierunek przewijania",
        "scrollSpeed": "Prędkość przewijania",
        "fontSize": "Rozmiar czcionki",
        "alignment": "Wyrównanie",
        "subtitle": "Napisy",
        "enterURL": "Proszę wprowadzić adres URL",
        "webPage": "Strona internetowa",
        "enterMediaURL": "Proszę wprowadzić adres URL strumienia",
        "media": "Strumień",
        "selectVideo": "Proszę wybrać wideo",
        "unsupportedFormat": "Nieobsługiwany format pliku, szczegółowe informacje o obsługiwanych formatach znajdziesz w Moje - Pomoc systemowa",
        "cancelAllSelections": "Proszę anulować wszystkie zaznaczone materiały przed przesłaniem nowych plików",
        "fileName": "Nazwa pliku",
        "fileSize": "Rozmiar pliku",
        "uploadProgress": "Postęp przesyłania",
        "cancelUpload": "Anuluj przesyłanie",
        "cancelAllUploads": "Anuluj wszystkie przesyłania",
        "leftToRights": "Od lewej do prawej",
        "rightToLefts": "Od prawej do lewej",
        "bottomToTops": "Od dołu do góry",
        "static": "Statyczny",
        "slow": "Wolny",
        "medium": "Średni",
        "fast": "Szybki",
        "colorValue": "Wartość koloru",
        "defaultEffect": "Domyślny efekt",
        "rightToLeft": "Od prawej do lewej",
        "leftToRight": "Od lewej do prawej",
        "topToBottom": "Od góry do dołu",
        "bottomToTop": "Od dołu do góry",
        "accordionSqueeze": "Efekt akordeonu",
        "zoomInFade": "Powiększanie z zanikiem",
        "zoomOutFade": "Pomniejszanie z zanikiem",
        "depthOfField": "Efekt głębi ostrości",
        "leftRightRotate": "Obrót w lewo i prawo",
        "upDownRotate": "Obrót w górę i w dół",
        "counterclockwiseRotate": "Obrót przeciwnie do wskazówek zegara",
        "clockwiseRotate": "Obrót zgodnie z ruchem wskazówek zegara",
        "upDownZoom": "Powiększanie i pomniejszanie w górę i w dół",
        "scaleFade": "Zanikanie ze skalowaniem",
        "zoomInDisappearing": "Powiększanie z zanikiem",
        "transparentFade": "Przezroczyste zanikanie",
        "gradientScale": "Skalowanie gradientowe",
        "deleteMaterial": "Usuń materiał",
        "confirmDeleteMaterial": "Czy na pewno chcesz usunąć ten materiał?",
        "unreviewed": "Niezrecenzowany",
        "normal2": "Normalny",
        "violating": "Naruszenie",
        "suspectedViolating": "Podejrzenie naruszenia",
        "delete": "Usuń",
        "selectMaterial": "Proszę wybrać materiał",
        "deleteProgramGroup": "Usuń grupę programów",
        "confirmDeleteGroup": "Czy na pewno chcesz usunąć tę grupę?",
        'add': 'Dodaj',
        'toggle_effect': 'Przełącz efekt',
        'toggle_time': 'Przełącz czas',
        "pub_toggle_time": "Przełącz czas",
        'fullscreen': 'Pełny ekran',
        'normal': 'Normalny',
        'interactive': 'Interaktywny',
        'main_screen': 'Główny ekran',
        'sub_screen': 'Ekran pomocniczy',
        'dual_screen': 'Podwójny ekran',
        'sync_task': 'Zadanie synchronizacji',
        'normal_mode': 'Tryb normalny',
        'basic_info': 'Podstawowe informacje',
        'program_info': 'Informacje o programie',
        'task_name': 'Nazwa programu',
        'task_type': 'Typ zadania',
        'pub_task': 'Zadanie zwykłe',
        'hu_task': 'Zadanie interaktywne',
        'no_data': 'Brak danych',
        'no_msg': 'Brak informacji',
        'program_name': 'Nazwa programu',
        'program_resolution': 'Rozdzielczość programu',
        'program_type': 'Typ programu',
        'screen_category': 'Kategoria ekranu',
        'edit_program': 'Edytuj program',
        'edit': 'Edytuj',
        'send': 'Wyślij',
        'create': 'Utwórz grupę',
        'reload': 'Odśwież',
        'name': 'Nazwa',
        'create_task_z': 'Utwórz grupę zadań',
        'ps_push_name': 'Proszę wprowadzić nazwę grupy',
        'device_list': 'Lista urządzeń',
        'delete_task_group': 'Usuń grupę zadań',
        'confirm_delete_group': 'Czy na pewno chcesz usunąć tę grupę?',
        'delete_success': 'Usunięto pomyślnie',
        'name_cannot_be_empty': 'Nazwa nie może być pusta',
        'character_length_limit': 'Długość nazwy musi być mniejsza niż 10 znaków',
        'create_task_success': 'Pomyślnie utworzono zadanie',
        'create_task_failed': 'Nie udało się utworzyć zadania',
        'confirm_delete_task': 'Czy na pewno chcesz usunąć to zadanie?',
        'task_details': 'Szczegóły zadania',
        "download_success": "Pomyślnie pobrano",
        "waiting_download": "Oczekiwanie na pobranie",
        "downloading": "Pobieranie",
        "confirm_delete": "Czy na pewno chcesz usunąć?",
        "confirm_delete_all": "Czy na pewno chcesz usunąć wszystko?",
        "confirm_delete_selected": "Czy na pewno chcesz usunąć wybrane?",
        "no_data_to_clear": "Brak danych do wyczyszczenia!",
        "refresh": "Odśwież",
        "clear_all": "Wyczyść wszystko",
        "clear_completed": "Wyczyść ukończone",
        "device_id": "ID urządzenia",
        "task_size": "Rozmiar zadania",
        "speed": "Prędkość",
        "download_progress": "Postęp pobierania",
        "title": "Tytuł",
        "volume": "Głośność",
        "deleteP": "Usuń program",
        "con_P": "Czy na pewno chcesz usunąć ten program?",
        "clear": "Wyczyść",
        "download_status": "Status pobierania",
        "height_width_cannot_be_empty": "Wysokość/szerokość nie mogą być puste",
        "add_success": "Pomyślnie dodano",
        "enter_number_between_300_to_8000": "Proszę wprowadzić liczbę między 300 a 8000",
        "width": "Szerokość",
        "enter_width": "Proszę wprowadzić szerokość",
        "height": "Wysokość",
        "enter_height": "Proszę wprowadzić wysokość",
        "confirm_leave_page": "Czy na pewno chcesz opuścić tę stronę?",
        "add_content_to_control": "Proszę dodać treść do kontrolki",
        "add_control": "Proszę dodać kontrolkę",
        "save_success": "Pomyślnie zapisano",
        "save": "Zapisz",
        "create_program": "Utwórz program",
        "guess": "Zgadnij",
        "modify": "Modyfikuj",
        "text": "Tekst",
        "image": "Obraz",
        "background_image": "Obraz tła",
        "background_music": "Muzyka w tle",
        "replace": "Zastąp",
        "use_this_template": "Użyj tego szablonu",
        "apply_template": "Zastosuj szablon",
        "enter_program_name": "Proszę wprowadzić nazwę programu",
        "program_group": "Grupa programów",
        "select_program_group": "Proszę wybrać grupę programów",
        "group_list": "Lista grup",
        "preview": "Podgląd",
        "my_apps": "Moje aplikacje",
        "template_center": "Centrum szablonów",
        "home": "Strona główna",
        "source_of_visit": "Źródło wizyty",
        "online": "Online",
        "terminal_status": "Status terminala",
        "memory_status": "Status pamięci",
        "login": "Zaloguj się",
        "sms_verification": "Weryfikacja SMS",
        "email_verification": "Weryfikacja e-mail",
        "log_in": "Zaloguj się",
        "enter_username": "Proszę wprowadzić nazwę użytkownika",
        "username_cannot_be_empty": "Nazwa użytkownika nie może być pusta",
        "password_cannot_be_empty": "Hasło nie może być puste",
        "incorrect_phone_format_for_verification_code": "Format numeru telefonu dla kodu weryfikacyjnego jest nieprawidłowy, proszę skontaktować się z administratorem w celu jego zmiany!",
        "incorrect_email_format_for_verification_code": "Format adresu e-mail dla kodu weryfikacyjnego jest nieprawidłowy, proszę skontaktować się z administratorem w celu jego zmiany!",
        "incorrect_phone_or_email_format_for_verification_code": "Format numeru telefonu lub adresu e-mail dla kodu weryfikacyjnego jest nieprawidłowy, proszę skontaktować się z administratorem w celu jego zmiany!",
        "reset_password": "Zresetuj hasło",
        "remember_password": "Zapamiętaj hasło",
        "register": "Zarejestruj konto",
        "current_version_4.1.6": "Wersja 4.1.8",
        "notification_about_network_security": "Powiadomienie o bezpieczeństwie sieci",
        "got_it": "Zrozumiano",
        "please_authenticate_for_account_safety": "Dla bezpieczeństwa Twojego konta, proszę przeprowadzić weryfikację tożsamości",
        "enter_account": "Proszę wprowadzić konto",
        "enter_password": "Proszę wprowadzić hasło",
        "verification_code": "Kod weryfikacyjny",
        "none": "Brak",
        "personal_center": "Centrum osobiste",
        "remote_control": "Zdalne sterowanie",
        "refresh_success": "Pomyślnie odświeżono!",
        "logout": "Wyloguj się",
        "confirm_logout": "Czy na pewno chcesz się wylogować?",
        "user_status": "Status użytkownika",
        "customer_address": "Adres klienta",
        "account_period": "Okres konta",
        "device_control": "Sterowanie urządzeniem",
        "clear_cache": "Wyczyść pamięć podręczną",
        "exit": "Wyjdź",
        "terminal": "Terminal",
        "program": "Program",
        "material": "Materiał",
        "my": "Moje",
        "display_type": "Typ wyświetlania",
        "proportion": "Proporcja",
        "resolution": "Rozdzielczość",
        "screen_orientation": "Orientacja ekranu",
        "landscape": "Poziomy",
        "portrait": "Pionowy",
        "add_resolution": "Dodaj rozdzielczość",
        "execute_formatting_when_focus_lost": "Wykonaj formatowanie po utracie fokusu",
        "select_resolution": "Proszę wybrać rozdzielczość",
        "resolution_list": "Lista rozdzielczości",
        "confirm_delete_program": "Czy na pewno chcesz usunąć program?",
        "confirm_delete_this_program": "Czy na pewno chcesz usunąć ten program?",
        "bound_tasks_exists_confirm_delete": "Zadania są przypisane, czy na pewno chcesz usunąć?",
        "prompt": "Podpowiedź",
        "delete_failed": "Usunięcie nie powiodło się",
        "modification_time": "Czas modyfikacji",
        "resolution_": "Rozdzielczość",
        "associated_tasks": "Powiązane zadania",
        "bound_task": "Przypisane zadanie",
        "program_management": "Zarządzanie programem",
        "task": "Zadanie",
        "progress": "Postęp",
        "phone_number": "Numer telefonu",
        "enter_phone_number": "Proszę wprowadzić numer telefonu",
        "password": "Hasło",
        "confirm_password": "Potwierdź hasło",
        "enter_password_again": "Proszę wprowadzić hasło ponownie",
        "company_name": "Nazwa firmy",
        "enter_company_name": "Proszę wprowadzić nazwę firmy",
        "address": "Adres",
        "enter_address": "Proszę wprowadzić adres kontaktowy",
        "username_not_exist": "Nazwa użytkownika nie istnieje",
        "enter_new_password": "Proszę wprowadzić nowe hasło",
        "enter_new_password_again": "Proszę wprowadzić nowe hasło ponownie",
        "terminal_management": "Zarządzanie terminalem",
        "delete_group": "Usuń grupę",
        "pel_select_group": "Proszę wybrać grupę",
        "enter_device_name": "Proszę wprowadzić nazwę urządzenia",
        "delete_device": "Usuń urządzenie",
        "confirm_delete_device": "Czy na pewno chcesz usunąć to urządzenie?",
        "terminal_information": "Informacje o terminalu",
        "qr_code_error": "Błąd kodu QR",
        "device_not_supported": "Urządzenie nie jest obsługiwane",
        "device_offline": "Wybrane urządzenie musi być online, aby wysłać polecenie. Proszę wybrać ponownie!",
        "more": "Więcej",
        "device_access": "Dostęp do urządzenia",
        "filter": "Filtr",
        "all": "Wszystkie",
        "offline": "Offline",
        "device_name": "Nazwa urządzenia",
        "device_number": "Numer urządzenia",
        "device_group": "Grupa urządzeń",
        "call_device_please_wait": "Wywoływanie urządzenia, proszę czekać...",
        "create_terminal_group": "Utwórz grupę urządzeń",
        "enter_search_keyword": "Proszę wprowadzić słowo kluczowe do wyszukiwania",
        "bind_device": "Przypisz urządzenie",
        "select_device_group": "Proszę wybrać grupę urządzeń",
        "authorized": "Autoryzowany",
        "unauthorized": "Nieautoryzowany",
        "adjust_volume": "Dostosuj głośność",
        "reboot_device": "Zrestartuj urządzenie",
        "wake_up": "Obudź",
        "sleep": "Uśpij",
        "shutdown": "Wyłącz",
        "clean_up_timing_on_off": "Wyczyść harmonogram",
        "clean_up_disk": "Wyczyść dysk",
        "clean_up_task": "Wyczyść zadanie",
        "send_command": "Wyślij polecenie",
        "confirm2": "Czy na pewno chcesz wysłać -",
        "terminal_operation": "Operacja terminala",
        "bind_task": "Informacje o zadaniu",
        "remote_command": "Polecenie zdalne",
        "remote_monitor": "Monitorowanie zdalne",
        "adding_one_will_override_the_previous": "Można dodać tylko jedno zadanie czasowe",
        "screenshot_in_progress_please_wait": "Trwa zrzut ekranu, proszę czekać",
        "schedule_on_off": "Harmonogram włączania/wyłączania",
        "shutdown_time": "Czas wyłączenia",
        "startup_time": "Czas włączenia",
        "volume_setting": "Ustawienie głośności",
        "edit_device_name": "Edytuj nazwę urządzenia",
        "please_select_time": "Proszę wybrać czas",
        "device_not_online_please_retry": "Urządzenie nie jest online, proszę spróbować ponownie",
        "sent_successfully": "Wysłano pomyślnie",
        "version": "Wersja V4.1.8",
        "texta": "Tekst",
        "userName": "Konto",
        "email": "E-mail",
        "device_memory": "Pamięć urządzenia",
        "device": "Urządzenie",
        "device_mac": "MAC urządzenia",
        "screen_count": "Liczba ekranów",
        "device_location": "Lokalizacja urządzenia",
        "is_authorized": "Czy autoryzowany",
        "remark": "Uwagi",
        "device_ip": "IP urządzenia",
        "system_version": "Wersja systemu",
        "playback_date": "Data odtwarzania",
        "playback_period": "Okres odtwarzania",
        "retrieve_again": "Ponownie pobierz",
        "please_enter_password": "Proszę wprowadzić hasło zawierające co najmniej 8 znaków, w tym cyfry, litery i znaki specjalne [@#$%^&+=]",
        "passwords_do_not_match": "Hasła nie są zgodne",
        "enter_new_password2": "Wprowadź nowe hasło",
        "current_password_too_simple": "Obecne hasło jest zbyt proste. Dla ochrony konta proszę je zmienić na hasło zawierające co najmniej 8 znaków, w tym cyfry, litery i znaki specjalne [@#$%^&+=]",
        "creation_time": "Czas utworzenia",
        "login2": "Zaloguj się",
        "welcome": "Witamy w systemie logowania",
        "expired_login": "Sesja logowania wygasła, proszę zalogować się ponownie",
        "control": "Zdalne sterowanie",
        "add_task": "Dodaj zadanie",
        "program_list": "Lista programów",
        "terminal_info": "Informacje o terminalu",
        "add_program": "Dodaj program",
        "material_management": "Zarządzanie materiałami",
        "change_password": "Zmień hasło",
        "enter_text_content": "Proszę wprowadzić treść tekstu",
        "hit_the_wall_on_back": "Za plecami jest ściana",
        "last_ceremony": "Ostatnia ceremonia",
        "already_top_level": "Już na najwyższym poziomie",
        "already_last_one": "Już ostatni raz",
        "white_fox": "Biała lisica",
        "control_img": "Obraz",
        "control_video": "Wideo",
        "control_streaming": "Strumieniowanie",
        "control_webPage": "Strona internetowa",
        "control_subtitle": "Napisy",
        "control_HDMI": "HDMI",
        "control_addbackground": "Tło",
        "Up": "Prześlij",
        "onlyOne": "Można dodać tylko jedną kontrolkę",
        "clearBg": "Usuń tło",
        "get_code": "Proszę najpierw wprowadzić kod weryfikacyjny",
        "del_Null_Program": "Czy na pewno chcesz wyczyścić listę zawierającą pusty program?",
        "please_select_date": "Proszę wybrać co najmniej jedną datę",
        "last_size": "Pozostała przestrzeń",
        "shutdown_tips": "Po wyłączeniu urządzenia nie można go włączyć zdalnie",
        "last_size_upload": "Proszę wybrać ponownie",
        "end_date_earlier_than_start_date": "Data zakończenia nie może być wcześniejsza niż data rozpoczęcia",
        "account_type": "Typ użytkownika",
        "user_type": "Zwykły użytkownik",
        "role_type": "Rola",
        "super_administrator": "Superadministrator",
        "term_info_empty": "Informacje o terminalu są puste",
        "select_terminal_prompt": "Proszę kliknąć przycisk listy w prawym górnym rogu, aby wybrać terminal",
        "select": "Wybierz",
        "data_empty": "Dane są puste!",
        "content_review": "Przegląd treści",
        "start_date": "Data rozpoczęcia",
        "end_date": "Data zakończenia",
        "start_time": "Czas rozpoczęcia",
        "end_time": "Czas zakończenia",
        "select_all": "Zaznacz wszystko",
        "select_group": "Wybierz grupę",
        "review": "Przegląd",
        "material_type": "Typ materiału",
        "audio": "Audio",
        "document": "Dokument",
        "material_status": "Status materiału",
        "material_review": "Przegląd materiału",
        "current_selection_requires_review": "Czy wybrany materiał wymaga przeglądu?",
        "invCode": "Kod zaproszenia",
        "tip_invitation_empty": "Proszę wprowadzić kod zaproszenia",
        "enter_userName": "Proszę wprowadzić nazwę użytkownika",
        "enter_email": "Proszę wprowadzić e-mail",
        "file_less_38": "Plik mniejszy niż 38KB",
        "viewError": "Ten plik nie obsługuje podglądu",
        "user": "Informacje osobiste",
        "phone_number_too_short": "Numer telefonu musi mieć więcej niż 9 cyfr",
        "oneImage": "Obraz tła już istnieje, aby przesłać nowy, proszę najpierw usunąć stary",
        "del_title": "Potwierdzenie usunięcia",
        "del_message": "Czy na pewno chcesz usunąć ten element?",
        "close": "Zamknij",
        "exit_group_name": "Edytuj nazwę grupy",
        "group_management": "Zarządzanie grupami",
        "language": "Zmiana języka",
        "mixture": "Mieszany",
        "date": "Data",
        "weeks": "Tygodnie",
        "time": "Czas",
        "new_password": "Nowe hasło",
        "enter_invCode": "Porada: Kod zaproszenia można uzyskać od administratora",
        "msg_password": "Porada: Proszę wprowadzić hasło zawierające co najmniej 8 znaków, w tym cyfry, litery i znaki specjalne [@#$%^&+=]",
        "oneDoc": "Dokument już istnieje, aby przesłać nowy, proszę najpierw usunąć stary",
        "Sunday": "Niedziela",
        "Monday": "Poniedziałek",
        "Tuesday": "Wtorek",
        "Wednesday": "Środa",
        "Thursday": "Czwartek",
        "Friday": "Piątek",
        "Saturday": "Sobota",
        "input_error": "Wszystkie pola formularza muszą być wypełnione",
        "video_tutorial": "Materiały instruktażowe",
        "view": "Oglądaj online",
        "selectDeviceOne": "To polecenie można wykonać tylko dla jednego urządzenia",
        "select_device_list": "Lista wybranych urządzeń",
        "small_size": "Mały",
        "medium_size": "Średni",
        "large_size": "Duży",
        "device_info": "Szczegóły urządzenia",
        "notification": "Powiadomienie",
        "notif_title": "Treść powiadomienia",
        "notif_msg": "Od 5 listopada 2024 r. Centrum Usług ETV usunie materiały przechowywane dłużej niż rok. Prosimy o wcześniejsze zabezpieczenie ważnych materiałów. Dziękujemy za zrozumienie i współpracę.",
        "reduce": "Zmniejsz",
        "bound_material": "Powiązany materiał",
        "tip_material": "Powiązany materiał nie może zostać usunięty, proszę najpierw rozwiązać powiązanie",
        "boundpo": "Powiązany program",
        "bind_progron": "Ten materiał jest powiązany z programem, nie można go usunąć",
        "index": "Indeks",
        "source": "Źródło",
        "getUploadSet_tip": "Nie udało się uzyskać ustawień przesyłania materiałów",
        "getUploadstartTime_tip": "Obecnie przesyłanie materiałów jest zabronione, proszę spróbować w innym czasie",
        "getUploadendTim": "Przesyłanie materiałów zabronione",
        "download": "Pobierz",
        "network_import": "Import sieciowy",
        "mobile_mode": "手机模式",
        "standalone_mode": "单机模式",
        "network_connection": "一、网络连接",
        "network_methods": "有以下两种网络连接方式：",
        "network_method_1": "（1）设置→网络和互联网→WLAN→连接网络→网络连接后打开ETV→网络图标变成白色，网络连接成功。",
        "network_method_2": "（2）打开ETV→点击鼠标右键→软件设置→选择网络下发，点击下一步→属性设置→WiFi设置→跳转到WiFi连接界面，连接网络→返回上一界面→退出回到ETV主界面→网络图标变成白色，网络连接成功。",
        "account_registration": "二、账号注册",
        "registration_methods": "有以下两种注册方法：",
        "registration_method_1": "（1）联系上级分配账号：上级用户登录账号→客户管理→添加客户→填写客户信息点击确定→新建成功，客户列表显示该账号信息。",
        "registration_method_2": "（2）自由注册账号：后台服务器登录界面→注册账号→按要求填写信息点击提交→注册成功。",
        "invitation_code_source": "邀请码来源：上级账户登录账号→系统配置→邀请码管理→新增邀请码。",
        "device_connection": "三、设备连接",
        "device_connection_steps": "打开ETV→点击鼠标右键→软件设置→选择网络下发，点击下一步→填写服务器地址（登录的后台服务器地址）、控制端口（默认8899）、用户名（上级分配或自主注册的账号用户名）→点击连接→连接成功后，设备端显示已连接，后台设备列表显示该设备信息。",
        "connect_terminal": "一、连接终端设备",
        'mobile_mode_tip':'（保持手机和设备在同一局域网下）',
        "scan_qr_wifi":'1. 手机连接设备热点，或者连接设备同一WIFI或同一局域网环境下的WIFI。',
        "scan_qr_code": "2. 左上角扫一扫：扫描终端二维码，进行连接设备。",
        "device_List": "3. 右上角设备列表：列表显示该局域网下的所有设备，勾选设备。",
        "remote_Command": "二、远程指令",
        "send_Command": "下发指令到终端设备，设备端进行相应响应",
        "quick_send_program": "三、快捷下发节目",
        "quick_send_steps": "下发快捷展示指令→获取本地图片、视频、文档素材，选择下发素材，点击确定→设置节目播放时间，点击确认→节目下发成功。",
        "program_creation": "四、节目制作",
        "new_program": "1. 新建节目：编辑至少两个字节的节目名称（会依据新建时间自动生成节目名称），根据终端设备显示屏选择屏幕方向、显示类型，新建成功后跳转到节目编辑界面。",
        "program_editing": "2. 节目编辑：选择节目播放模式（替换、插播、追加），点击“<img src='/static/images/help/icon.png' alt='' />”添加控件（图片、视频、混播、文档等），可自由调节控件大小和位置，点击“<img src='/static/images/help/icon_2.png' alt='' />”添加素材，下方可设置控件的各种属性。",
        "program_sending": "五、节目发送",
        "send_program_steps": "制作好节目→点击发送→弹出设备列表，勾选设备→点击确定→跳转到下载进度界面，显示下载进度→下载100%之后显示完成→设备端播放所下发的节目。",
        "simple_mode_title": "一、简易模式（默认）",
        "simple_mode_description": "此模式为单机默认导入方式，只需把图、视素材放在U盘的根目录下再使用U盘插入主板即可导入成功；",
        "simple_mode_note": "（PS：只支持图、视导入，相当于一个混播插件，如需其它场景则需采用单机第二种方式即可）",
        "regular_mode_title": "二、常规模式",
        "regular_mode_description": "勾选“单机模式”，点击下一步，即可出现单机模式界面（如下图)",
        "regular_mode_steps": "1. 主屏布局即可进入主屏布局页面设置<br>2.点击副屏布局即可进入副屏布局设置",
        "step_one": "第一步：",
        "step_one_description": "插上U盘，在U盘根目录新建一个文件夹，命名为“etv-media”，在etv-media目录下新建“main”文件夹，如果需要发布双屏任务，在etv-media目录下新建“double”文件夹",
        "step_two": "第二步：",
        "step_two_description": "根据选择的主屏或副屏布局，在main或double中新建1/2/3/4和布局相对应的文件夹即可",
        "step_three": "第三步：",
        "step_three_description": "将对应的布局的图片/视频文件拷贝到对应main/double文件夹下的1/2/3/4文件夹中",
        "step_four": "第四步：",
        "step_four_description": "支持全屏PDF文档播放，仅允许放一个",
        "step_five": "第五步：",
        "step_five_description": "音频请放置MAIN/DOUBLE.目录下即可，系统自动循环切换",
        "play_order_title": "播放顺序：",
        "play_order_description": "1：优先播放以数字命名的文件，数字按照从小到大的播放顺序来播<br>2：其次播放以字母命名的文件，字母按照从A到Z的播放顺序来播<br>3：最后播放以汉字命名的文件，汉字以第一个文字的首字母从A到Z的播放顺序来播",
        "document_playback_note": "关于文档播放（此开关默认打开）：3128主板和M11主板显示文档开关默认关闭（节约性能开销），需要手动开启显示文档开关",
        "program_review": "Przegląd programu",
        "pass": "Zatwierdź",
        "not_passed_or_not_reviewed": "Nie zatwierdzono lub nie przejrzano",
        "play_mode": "Tryb odtwarzania",
        "review_status": "Status przeglądu",
        "reject": "Odrzuć",
        "review_content": "Treść przeglądu",
        "enter_review_content": "Proszę wprowadzić treść przeglądu",
        "device_quantity": "Liczba urządzeń",
        "system_help": "Pomoc systemowa",
        "updateInfo": "Informacje o aktualizacji",
        "Formatspecification": "Specyfikacja formatu",
        "fileFormat": "Format pliku",
        "imgFormat": "Format obrazu",
        "audioFormat": "Format audio",
        "videoFormat": "Format wideo",
        "updated": "Data aktualizacji",
        "details": "1: Dodano menu Pomoc systemowa w sekcji Moje<br>2: Dodano typy przesyłanych materiałów, przesyłanie do chmury Tencent, synchronizacja z ustawieniami na PC<br>3: Optymalizacja funkcji wyświetlania materiałów",
        "nameLengthLimit": "名称长度请限制在50字符以内",
    },
    vanDialog: {
        "confirm": "Potwierdź",
        "cancel": "Anuluj"
    },
    vanPicker: {
        "confirm": "Potwierdź",
        "cancel": "Anuluj"
    },
    vanDatetimePicker: {
        "title": "Wybierz datę"
    },

}